import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const SubscriptionModal = ({
  open,
  type, // "NO_SUBSCRIPTION" | "LIMIT_EXCEEDED"
  onClose
}) => {
  const navigate = useNavigate();

  const isNoSubscription = type === "NO_SUBSCRIPTION";

  const title = isNoSubscription
    ? "Subscription Required"
    : "Upload Limit Reached";

  const message = isNoSubscription
    ? "You don’t have an active subscription. Please take a subscription to post properties."
    : "You have reached your property upload limit. Please upgrade your subscription to continue.";

  const actionLabel = isNoSubscription
    ? "Take Subscription"
    : "Upgrade Subscription";

  const handleSubscription = () => {
    navigate("/user-subscription");
  };

  const handleCancel = () => {
    navigate("/dashboard");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: "bold" }}>
        {title}
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" sx={{ mt: 1 }}>
          {message}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button
          variant="outlined"
          onClick={handleCancel}
          sx={{ borderRadius: 2 }}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={handleSubscription}
          sx={{
            borderRadius: 2,
            backgroundColor: "#8B4513",
            "&:hover": { backgroundColor: "#654321" }
          }}
        >
          {actionLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubscriptionModal;
